<template>
  <a-layout>
    <Breadcrumb>
      <BreadcrumbItem> {{ pageTitle }} </BreadcrumbItem>
    </Breadcrumb>
    <div class="page-title-container">
      <div>
        <span class="page-title">用户信息</span>
        <p style="color: gray;">默认密码：{{ initialPwd }} 由用户自行修改</p>
      </div>
    </div>

    <div class="content-container">
      <div class="container">
        <div class="steps-content">
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label">真实姓名</span><span class="required-mark">*</span>
            </div>
            <div class="field-content">
              <a-input v-model="user.realName" class="medium-input" />
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label">手机号</span><span class="required-mark">*</span>
            </div>
            <div class="field-content">
              <a-input v-model="user.mobile" class="medium-input" />
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label">性别</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="user.gender" name="radioGroup">
                <a-radio value="男">
                  男
                </a-radio>
                <a-radio value="女">
                  女
                </a-radio>
              </a-radio-group>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label">角色</span><span class="required-mark">*</span>
            </div>
            <div class="field-content">
              <a-select
                  placeholder="请选择"
                  mode="multiple"
                  v-model="user.roleIds"
                  class="search-select"
              >
                <a-select-option v-for="role in roleList" :key="role.sysRoleId" :value="role.sysRoleId">
                  {{ role.roleName }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label">合作方</span>
            </div>
            <div class="field-content">
              <a-select
                  placeholder="请选择"
                  v-model="user.partnerId"
                  class="search-select"
              >
                <a-select-option v-for="item in partnerOptions" :key="item.partnerId" :value="item.partnerId">
                  {{ item.partnerName }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>

        <div class="action-container action-container__bottom">
          <a-button
              type="primary"
              @click="onSubmit"
              class="draft-btn"
          >
            保存
          </a-button>
          <a-button @click="showUserPage">
            取消
          </a-button>
        </div>
      </div>
    </div>
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import { createUser, loadUser, fetchInitialPwd } from "@/services/UserService";
import {fetchRoleList} from "@/services/RoleService";
import {listOptions} from "@/views/partner/PartnerApi";

export default {
  components: { BreadcrumbItem, Breadcrumb },
  data() {
    return {
      pageTitle: "新增用户",
      id: "",
      roleList:[],
      initialPwd: "",
      partnerOptions: [],
      user: {
        userId: "",
        realName: "",
        mobile: "",
        gender: "",
        roleIds: [],
        partnerId: ""
      },
    };
  },
  created() {
    this.id = this.$route.params.id;
    if(this.id==='0') {
      this.id = "";
    } else {
      this.pageTitle = "编辑用户";
    }
    listOptions().then(response => {
      if (response.data.code === "SUCCESS") {
        this.partnerOptions = response.data.data;
      }
    });
    fetchRoleList().then(response => {
      if (response.data.code === "SUCCESS") {
        this.roleList = response.data.data;
      } else {
        this.$message.error("读取角色列表失败");
      }
    });
  },
  mounted() {
    this.startLoadUser();
    this.startFetchInitPwd();
  },
  methods: {
    startLoadUser() {
      if (this.id && this.id !== "") {
        loadUser(this.id).then(resp => {
          if (resp.data.code === "SUCCESS") {
            this.user = resp.data.data;
          } else {
            this.$message.error("读取用户信息失败");
          }
        });
      }
    },
    startFetchInitPwd(){
      fetchInitialPwd().then(response => {
        if (response.data.code === "SUCCESS") {
          this.initialPwd = response.data.data;
        } else {
          this.$message.error("读取初始密码失败");
        }
      });
    },
    showUserPage() {
      this.$router.push({ name: "UserList" });
    },
    validateForm(){
      if(!this.user.realName) {
        return "请输入姓名";
      }
      const regex = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;

      if(!this.user.mobile) {
        return "请输入手机号码";
      } else if (!regex.test(this.user.mobile)) {
        return "手机号码格式不正确";
      }
      if(this.user.roleIds && this.user.roleIds.length === 0) {
        return "请选择角色";
      }
      return "";
    },
    onSubmit(){
      let validateMsg = this.validateForm();
      console.log("validateMsg", ">"+validateMsg+"<");
      if(validateMsg===""){
        let params = {
          ...this.user,
        }

        console.log("保存参数", params);
        createUser(params).then(response => {
          if (response.data.code === "SUCCESS") {
            this.$message.success("操作成功");
            this.$router.push({ name: "UserList" });
          } else {
            this.$message.error(response.data.errorMsg);
          }
        });
      } else {
        this.$message.error(validateMsg);
      }
    },
  }
}
</script>
<style scoped>

.long-input {
  max-width: 80%;
}
.medium-input {
  max-width: 60%;
}
.remark-input {
  max-width: 30%;
}
.field-label-container {
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.85)
}
.draft-btn {
  margin-right: 30px;
}
</style>
